import { render, staticRenderFns } from "./FloatingWindow.vue?vue&type=template&id=21762a46&scoped=true"
import script from "./FloatingWindow.vue?vue&type=script&lang=js"
export * from "./FloatingWindow.vue?vue&type=script&lang=js"
import style0 from "./FloatingWindow.vue?vue&type=style&index=0&id=21762a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21762a46",
  null
  
)

export default component.exports